import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    yes: {
        id: 'iaso.label.yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'iaso.label.no',
        defaultMessage: 'No',
    },
    delete: {
        id: 'iaso.label.delete',
        defaultMessage: 'Delete',
    },
});

export default MESSAGES;
